import React from 'react';

interface ArrowRightProps {
  size?: number;
}

const ArrowRight: React.FC<ArrowRightProps> = ({ size = 7 }) => {
  return (
    <svg
      width={size}
      height={size * 2}
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.935486 1L5.7742 7L0.935486 13"
        stroke="#2B6ED2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ArrowRight };
